import { createSelector } from 'reselect';
import get from 'lodash/get';
import { goals as goalsSelector, financialPlan } from '../FinancialPlan/FinancialPlanSelector';
import { DEFAULT_DROPDOWN_SELECTION } from './FinancialPlanGoalDropdownReducer';
import { currentClientIdSelector } from '../CommonSelectors/CommonAreaSelector';

export const financialPlanGoalDropdownSelector = state => state.FinancialPlanGoalDropdown;

export const clientFinancialPlanGoalDropdownSelector = createSelector(
  financialPlanGoalDropdownSelector,
  currentClientIdSelector,
  (financialPlanGoalDropdown, clientId) => financialPlanGoalDropdown[clientId] || {},
);

export const selectedGoalSelector = createSelector(
  clientFinancialPlanGoalDropdownSelector,
  goalsSelector,
  (financialPlanGoalDropdown, goals) => {
    const { subGoalTypeId, goalId } = financialPlanGoalDropdown;
    const selectedGoal = goals.find(goal => goal.GoalId === goalId);

    if (selectedGoal && selectedGoal.DebtOutputPerType && Number.isInteger(subGoalTypeId)) {
      const { DebtOutputPerType } = selectedGoal;
      const subGoalData = DebtOutputPerType.find(
        ({ DebtType }) => parseInt(subGoalTypeId, 10) === DebtType,
      );
      return {
        ...subGoalData,
        GoalName: subGoalData.TabLabel,
        GoalType: selectedGoal.GoalType,
        GoalId: selectedGoal.GoalId,
        DebtType: subGoalData.DebtType,
        isSubGoal: true,
      };
    }

    if (selectedGoal) {
      return selectedGoal;
    }

    return DEFAULT_DROPDOWN_SELECTION;
  },
);

export const goalType = createSelector(selectedGoalSelector, ({ GoalType }) => GoalType);

export const goalId = createSelector(selectedGoalSelector, selectedGoal =>
  selectedGoal ? selectedGoal.GoalId : null,
);

export const selectedGoalName = createSelector(selectedGoalSelector, selectedGoal =>
  selectedGoal ? selectedGoal.GoalName : '',
);

export const selectedGoal = createSelector(
  selectedGoalSelector,
  selectedGoalItem => selectedGoalItem || {},
);

export const goalViewState = createSelector(
  goalId,
  currentClientIdSelector,
  financialPlan,
  (id, clientId, fp) => {
    if (!id) {
      throw Error('Invalid goalId');
    }
    return get(fp, `${clientId}.${id}`, {});
  },
);

export const nullableGoalViewStateSelector = createSelector(
  goalId,
  currentClientIdSelector,
  financialPlan,
  (id, clientId, fp) => {
    if (!id) {
      return null;
    }
    return get(fp, `${clientId}.${id}`, {});
  },
);

export const goalsList = createSelector(
  clientFinancialPlanGoalDropdownSelector,
  selector => selector.goals || [],
);
